var render = function render(){var _vm=this,_c=_vm._self._c;return _c('x-icon',{attrs:{"color":_vm.icon.color}},[_vm._v(_vm._s(_vm.icon.icon))])
}
var staticRenderFns = []

export { render, staticRenderFns }